{
  "unsubscribe_title": "Darse de baja de los correos electrónicos",
  "unsubscribe_message": "Lamentamos verte partir.",
  "unsubscribe": "Darse de baja",
  "cancel": "Cancelar",
  "passwordResetSuccess": "Tu contraseña ha sido cambiada exitosamente.",
  "passwordResetError": "Desafortunadamente, hubo un problema",
  "passwordResetExpired": "Este enlace no es válido o ha caducado. Solicita un nuevo correo para restablecer tu contraseña.",
  "passwordResetTooShort": "Usa al menos {min} caracteres.",
  "passwordResetTooLong": "Esta contraseña es demasiado larga. Elige una más corta.",
  "passwordResetTooWeak": "Esta contraseña es demasiado fácil de adivinar. Elige otra.",
  "passwordResetTooManyAttempts": "Demasiados intentos. Espera unos minutos y vuelve a intentarlo.",
  "passwordResetTooManyAttemptsMinutes": "Demasiados intentos. Vuelve a intentarlo en {minutes} min.",
  "passwordResetNetworkError": "Sin conexión. Revisa tu conexión a internet y vuelve a intentarlo.",
  "passwordResetTryAgain": "No ha funcionado. Vuelve a intentarlo en un momento.",
  "passwordResetTitle": "Establecer una nueva contraseña",
  "new_password": "Nueva contraseña",
  "confirm_password": "Confirmar nueva contraseña",
  "save": "Guardar",
  "error": "Desafortunadamente, hubo un problema",
  "unsubscribeSuccess": "La acción fue exitosa",
  "emailChangeLoading": "Cambio de correo electrónico en proceso...",
  "emailChangeSuccess": "El correo electrónico fue cambiado exitosamente",
  "emailChangeError": "Desafortunadamente, hubo un problema al cambiar el correo electrónico"
}
